const api = async ( action = 'get', params = {} ) => {
	try {
		return await jQuery.post( `${ QalaWishlist.homeurl }?wc-ajax=qala-wishlist-${ action }`, params );
	} catch ( error ) {
		// eslint-disable-next-line no-console
		console.error( error );
	}
};

export const all = async () => {
	return await api( 'all' );
};

export const get = async listId => {
	return await api( 'get', { list_id: listId } );
};

export const reset = async listId => {
	return await api( 'reset', { list_id: listId } );
};

export const addProductToList = async ( listId, productId ) => {
	return await api( 'add-product-to-list', {
		list_id: listId,
		product_id: productId,
	} );
};

export const removeProductFromList = async ( listId, productId ) => {
	return await api( 'remove-product-from-list', {
		list_id: listId,
		product_id: productId,
	} );
};

export default api;
